import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ActionSteps } from '../components/ActionSteps';
import { WarningBox } from '../components/WarningBox';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-carbon-900 text-gray-300 font-sans selection:bg-gold-500/30 selection:text-gold-200 flex flex-col relative overflow-hidden" data-id="element-70">
      {/* Global Background Noise/Texture (Optional subtle effect) */}
      <div className="fixed inset-0 opacity-[0.015] pointer-events-none mix-blend-overlay z-0" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
    }} data-id="element-71"></div>

      <Header data-id="element-72" />

      <main className="flex-1 flex flex-col w-full relative z-10" data-id="element-73">
        <Hero data-id="element-74" />
        <ActionSteps data-id="element-75" />
        <WarningBox data-id="element-76" />
      </main>

      <Footer data-id="element-77" />
    </div>;
}